<template>
  <b-dropdown variant="link"
              toggle-tag="a"
              v-if="canSendViaWhatsApp || canSendViaMax">
    <template #button-content>
      <button class="btn-themed btn-themed-squared btn-themed-outline btn-sm btn-themed-squared-rounder">
        <slot/>
      </button>
    </template>
    <b-dropdown-item v-if="canSendViaWhatsApp"
                     @click="sendClicked('whatsapp')">
      Whatsapp
    </b-dropdown-item>
    <b-dropdown-item v-if="canSendViaWhatsApp"
                     @click="sendClicked('telegram')">
      Telegram
    </b-dropdown-item>
    <b-dropdown-item v-if="canSendViaMax"
                     @click="sendClicked('max')">
      Max
    </b-dropdown-item>
  </b-dropdown>
</template>

<script setup>
import {useStore} from "vuex"
import {computed} from "vue"

const emit = defineEmits(['sendClicked'])

const store = useStore()
const getters = store.getters

const canSendViaWhatsApp = computed(() => getters.canSendViaWhatsApp)
const canSendViaMax = computed(() => getters.maxEnabled)

const sendClicked = (platform) => {
  emit("sendClicked", platform)
}
</script>
